// extracted by mini-css-extract-plugin
export var buttons = "index-module--buttons--2mdch";